<template>
    <section class="video">
        <video class="video-pause" id="video" loop controls preload="auto" :poster="'/static/video/bimbi.jpg'" title="Bimbi">
            <source :src="'/static/video/bimbi.m4v'" type="video/mp4" />
            <source :src="'/static/video/bimbi.webm'" type="video/webm" />
            <source :src="'/static/video/bimbi.ogv'" type="video/ogg" />
            <!-- <source :src="'/static/video/test.mp4'" /> -->
        </video> 
        <div class="video__bear" id="bear"></div>
        <div class="container">
            <div :class="{'video--active': isActive, video__play: true}" id="play_btn" @click="toggle_active()"></div>
        </div>
        <div class="arrow-down-jump"></div>
    </section>
</template>

<script>
export default {
    name: 'video',
    data () {
        return {
            isActive: true
        }
    },
    methods: {
        toggle_active () {
            this.isActive = !this.isActive
            let videoEl = document.getElementById('video')
            let bear = document.getElementById('bear')
            if (this.isActive) {
                videoEl.pause()
                videoEl.classList.add('video-pause')
                bear.style.display = 'block'
            } else {
                videoEl.play()
                videoEl.classList.remove('video-pause')
                bear.style.display = 'none'
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/video.vue?7d597087